import { setAside } from "store/types";

const initialState = {
    setAsides: [],
}


const reducer = (state = initialState, action) => {
    switch(action.type) {
        case setAside.GET_SET_ASIDES: {
            return {
                ...state,
                setAsides: action.payload
            }
        }
        default: {
            return state
        }
    }
}

export default reducer